module.exports = new __parcel__URL__("mnet_plus_logo.a82f6a00.png").toString();